// extracted by mini-css-extract-plugin
export default {"contact_wrapper":"DataDealingContact_contact_wrapper__2Sd8t","main":"DataDealingContact_main__GcQtm","contact_title":"DataDealingContact_contact_title__4IQOw"};